export interface LocationLiceReportWeekCandidate {
    isoWeek: number;
    isoYear: number;
    interimReport: boolean;
    /** Locations in a stored week. Empty on the running week until it is stored. */
    locationIds: readonly number[];
}

/**
 * The week a location report opens on. Newest first.
 *
 * A stored week is eligible only when this site is in it, so a newer week that belongs to
 * other sites is left in the selector but not selected. The running week is not stored yet,
 * so it stays eligible until `skipKeys` says the fetch came back without this site.
 */
export function defaultLocationLiceReportWeek(
    weeks: readonly LocationLiceReportWeekCandidate[],
    locationId: number,
    skipKeys: ReadonlySet<string>
): LocationLiceReportWeekCandidate | undefined {
    for (const week of weeks) {
        const key = `${week.isoWeek}-${week.isoYear}`;
        if (skipKeys.has(key)) {
            continue;
        }
        if (week.interimReport || week.locationIds.includes(locationId)) {
            return week;
        }
    }
    return undefined;
}
